import React, { Component } from "react";
import { Link } from "react-router";

import BandStore from "../../stores/BandStore";
import BandForm from "../../components/BandForm";

class CreateBand extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      list: {
        channels: [],
      },
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(list) {
    BandStore.createBand(list, (responseData) => {
      this.context.router.push("/bands");
    });
  }

  render() {
    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/bands">Band</Link></li>
          <li className="active">create band</li>
        </ol>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <BandForm list={this.state.list} onSubmit={this.onSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default CreateBand;



// WEBPACK FOOTER //
// ./src/views/bands/CreateBand.js